import { Fragment } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { AlignmentsTitle } from "../../../Constants/Constants";
import { AlignmentData, AlignmentsSubTitle } from "../../../Data/UiKits/Dropdown";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import DropdownCommon from "./Common/DropdownCommon";

const Alignments = () => {
  return (
    <Col lg="12">
      <Card>
        <CommonCardHeader title={AlignmentsTitle} span={AlignmentsSubTitle} />
        <CardBody className="rtl-dropdown">
          <div className="common-flex">
            {AlignmentData &&
              AlignmentData.map((item, index) => (
                <Fragment key={index}>
                  <DropdownCommon item={item} />
                </Fragment>
              ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default Alignments;
